import { render, staticRenderFns } from "./CourseBuilderUploadForm.vue?vue&type=template&id=15209ce1&scoped=true&"
import script from "./CourseBuilderUploadForm.vue?vue&type=script&lang=js&"
export * from "./CourseBuilderUploadForm.vue?vue&type=script&lang=js&"
import style0 from "./CourseBuilderUploadForm.vue?vue&type=style&index=0&id=15209ce1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15209ce1",
  null
  
)

export default component.exports